<template>
    <div class="flex flex-wrap my-3">
        <div class="w-1/2 md:w-1/4 flex flex-col">
            <label for="hours" class="my-2">Minutos</label>

            <quantity-button
                v-model="minutes"
                min="0"
                max="59"
                :disabled="!enabled"
                class="mx-2"
                @change="onInput"
            />
        </div>

        <div class="w-1/2 md:w-1/4 flex flex-col">
            <label for="hours" class="my-2">Horas</label>

            <quantity-button
                v-model="hours"
                max="24"
                min="0"
                :disabled="!enabled"
                class="mx-2"
                @change="onInput"
            />
        </div>
        <div class="w-1/2 md:w-1/4 flex flex-col">
            <label for="hours" class="my-2">Días</label>
            <quantity-button
                v-model="days"
                class="mx-2"
                max="30"
                min="0"
                :disabled="!enabled"
                @change="onInput"
            />
        </div>

        <div class="w-1/2 md:w-1/4 flex flex-col">
            <label for="hours" class="my-2">Meses</label>
            <quantity-button
                v-model="months"
                max="12"
                min="0"
                :disabled="!enabled"
                class="mx-2"
                @change="onInput"
            />
        </div>
    </div>
</template>

<script>
import QuantityButton from "@/components/utils/QuantityButton.vue";

export default {
    name: "PrepareTimeManager",
    components: { QuantityButton },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => ({
                minutes: 0,
                hours: 1,
                days: 0,
                months: 0
            }),
            type: Object,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        minutes: 0,
        hours: 1,
        days: 0,
        months: 0
    }),
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        setInput(value) {
            this.minutes = value.minutes;
            this.months = value.months;
            this.hours = value.hours;
            this.days = value.days;
        },
        onInput() {
            this.$emit("change", {
                minutes: this.minutes,
                months: this.months,
                hours: this.hours,
                days: this.days
            });
        }
    }
};
</script>
